import { InternalUserPicker } from "@/components/users/InternalUserPicker";

// WS2 — Step 3 "Who's working it" of the Send Signup Link wizard. The
// sending staff member is auto-assigned on the backend regardless of
// what this picker contains; the chip is read-only and "Also assign to"
// is the optional teammate list.

export interface Step3AssigneesProps {
  me: { id: string; displayName: string } | null;
  teammateIds: string[];
  onTeammateIdsChange: (ids: string[]) => void;
}

export function Step3Assignees({
  me,
  teammateIds,
  onTeammateIdsChange,
}: Step3AssigneesProps) {
  return (
    <div className="flex flex-col gap-space-3">
      <p className="text-small text-gray-mid m-0 max-w-reading">
        You're assigned to this account automatically. Add teammates who
        will also work it.
      </p>

      <section className="flex flex-col gap-space-2">
        <h3 className="font-display font-bold text-small uppercase tracking-wider text-gold-shadow">
          Assigned to
        </h3>
        <div className="flex flex-col gap-space-2 bg-white-pure rounded-lg border border-border-light p-space-4">
          {me && (
            <div className="flex flex-wrap items-center gap-space-1">
              <span className="inline-flex items-center gap-space-1 px-space-2 py-[2px] bg-gold/15 text-onyx rounded-full text-caption font-display">
                {me.displayName}
                <span className="text-[10px] uppercase tracking-wide text-gold-shadow">
                  You
                </span>
              </span>
            </div>
          )}
          {/* The picker is NOT wrapped in a <label>: a label forwards clicks
              to its inner search input, which swallowed the dropdown selection. */}
          <div className="flex flex-col gap-space-1 text-small text-onyx">
            <span>Also assign to</span>
            <InternalUserPicker
              value={teammateIds}
              onChange={(ids) =>
                onTeammateIdsChange(ids.filter((id) => id !== me?.id))
              }
              placeholder="Add a teammate by name, email, or role code…"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
